import { Component, ViewEncapsulation, OnInit, AfterViewChecked } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { Router } from '@angular/router';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';

declare var jQuery: any;

@Component({
    selector: 'app-agenda-virtual',
    templateUrl: './ingreso-agenda-virtual.template.html',
    styleUrls: ['./ingreso-agenda-virtual.component.scss'],
    encapsulation: ViewEncapsulation.None,
    // providers: [UrlService]
})

/**
 * @author jnmartinez
 */
export class IngresoAgendaVirtualComponent implements OnInit{ //, AfterViewChecked {

    documentos: any[] = [];
    visitante: any;
    iconImage: string = undefined;
    isPasaporte = false;
    visible = true;
    siteKey: string;
    secretKey: string;
    parametros: string[] = [DominiosService.LLAVE_CAPTCHA];

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utils: UtilService,
        public router: Router
    ) { }

    ngOnInit() {
        this.visitante = {};
        this.consultarParametros();
        this.getTipoIdentificacion();
    }

    //ngAfterViewChecked() {
	ngAfterContentInit(){
        this.iconImage = this.global.icon;
    }

    private consultarParametros() {
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_TRANS);
        this.global.postPublico(url, this.parametros).subscribe(
            data => {
                if (data.length > 0) {
                    data.forEach(element => {
                        switch (element.nombre) {
                            case DominiosService.LLAVE_CAPTCHA:
                                this.siteKey = element.valor;
                                break;
                            default:
                                this.secretKey = element.valor;
                                break;
                        }
                    });
                } else {
                    this.alertService.generateAlertError('Se presentó un error al cargar los datos iniciales', 'Error');
                }
            });
    }

    /**
     * obtiene el dominio tipo identificacion
     * @author jnmartinez
     */
    public getTipoIdentificacion() {
        this.spinner.show();
        const serviceProvider = 'getTipoIdentificacion';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.getPublico(url).subscribe(
            data => {
                this.documentos = data;
                this.spinner.hide();
            }, err => {
                this.spinner.hide();
                this.alertService.generateAlertError('Se presentó un error al cargar los datos iniciales', 'Error');
            }
        );
    }

    validarCampos() {
        return this.utils.validarCamposObligatorios(this.visitante.tipoDocVisitante)
            && this.utils.validarCamposObligatorios(this.visitante.numDocVisitante);
    }

    resolved(captchaResponse: string) {
        const formData = new FormData();
        formData.append('respuesta', captchaResponse);
        const url = this.urlService.getUrlTransversal(new UrlControl('ValidarCaptcha', null, null), this.urlService.hostAPI_TRANS);
        this.global.postTr(url, formData).subscribe(
            data => {
                this.consultarTurnos();
            }, error => {
                this.visible = false;
                this.utils.cathException(error, this.alertService, this.spinner);
                setTimeout(() => {
                    this.visible = true;
                }, 500);
            });
    }


    consultarTurnos() {
        if (!this.validarCampos()) {
            this.alertService.generateAlertError('Los campos marcados con * son obligatorios', '');
            return;
        }
        this.spinner.show();
        const url = this.urlService.getUrlUAC(new UrlControl('CiudadanoTieneAgenda', null, null), this.urlService.hostAPI_UAC);
        this.global.postPublico(url, this.visitante).subscribe(
            data => {
                sessionStorage.setItem(ConstantesService.TIPO_DOC_SESSSION, this.visitante.tipoDocVisitante);
                sessionStorage.setItem(ConstantesService.NUM_DOC_SESSSION, this.visitante.numDocVisitante);
                this.spinner.hide();
                if (Number(data.valor) > 0) {
                    // redireccion consulta turnos
                    this.router.navigate(['agenda-virtual/cancelar-agenda-virtual']);
                } else {
                    // redireccion solicitar turno
                    this.alertService.generateAlertError(
                        'Apreciado(a) ciudadano(a) le informamos que el documento ingresado no tiene turno asignado', '');
                    this.router.navigate(['agenda-virtual/solicitar-agenda-virtual']);
                }
            }, err => {
                if (err.status == '500') {
                    this.cathException(err.error.message);
                } else {
                    this.cathException('El reporte no se ha podido generar');
                }
            }
        );
    }

    validarTipoDocumento() {
        if (this.visitante.tipoDocVisitante == DominiosService.TIPO_DOCUMENTO_PASAPORTE
            || this.visitante.tipoDocVisitante == DominiosService.TIPO_DOCUMENTO_EXTRANJERIA) {
            this.isPasaporte = true;
        } else {
            this.isPasaporte = false;
        }
        this.visitante.numDocVisitante = undefined;
    }

    /**
     * Método de control de Excepciones
     * @param  error mensaje saliente respecto al error ocurrido
     * @return void
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    descargarManualPDF(): string {
        window.open(location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/acvis-web/assets/files/manual.pdf', '_blank');
        //window.location.href = 
        return '';
    }
}
